import { render, staticRenderFns } from "./merchantCreateCompetitionAudit.vue?vue&type=template&id=6881c537&scoped=true"
import script from "./merchantCreateCompetitionAudit.vue?vue&type=script&lang=ts"
export * from "./merchantCreateCompetitionAudit.vue?vue&type=script&lang=ts"
import style0 from "./merchantCreateCompetitionAudit.vue?vue&type=style&index=0&id=6881c537&prod&lang=stylus&scoped=true"
import style1 from "./merchantCreateCompetitionAudit.vue?vue&type=style&index=1&id=6881c537&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6881c537",
  null
  
)

export default component.exports